<template>
  <div class="ebook-cta-section">
    <div class="cta-container">
      <p class="cta-step">ÚLTIMO PASO</p>
      <h2 class="cta-title">¿Listo para dejar atrás el caos de Excel?</h2>
      <p class="cta-description">
        Completa el formulario y recibe el PDF + <strong>checklist</strong> +
        <strong>plantillas</strong> para una migración ordenada hacia un mantenimiento más
        predecible y auditable.
      </p>
      <button class="download-cta" @click="scrollToForm">
        <span>Descargar ebook</span>
        <span class="material-symbols-outlined">arrow_forward</span>
      </button>
      <p class="cta-info">Descarga inmediata • Enlace por correo • Sin spam</p>
    </div>
  </div>
</template>

<script setup lang="ts">
const scrollToForm = () => {
  const formSection = document.getElementById('ebook-form-section')
  if (formSection) {
    formSection.scrollIntoView({ behavior: 'smooth' })
  }
}
</script>

<style scoped>
.ebook-cta-section {
  padding: 80px 20px;
  background: #129bef;
  color: white;
  text-align: center;
  min-height: 50vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cta-container {
  max-width: 800px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.cta-step {
  font-size: 1rem;
  font-weight: 600;
  text-transform: uppercase;
  margin: 0;
  opacity: 0.8;
}

.cta-title {
  font-size: clamp(2rem, 4vw, 2.2rem);
  font-weight: 700;
  line-height: 1.2;
  margin: 0;
}

.cta-description {
  font-size: 1.15rem;
  line-height: 1.6;
  margin: 0;
  max-width: 700px;
  opacity: 0.9;
}

.cta-description strong {
  font-weight: 700;
}

.download-cta {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 15px 30px;
  background-color: #fff;
  color: #129bef;
  border: none;
  border-radius: 50px;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.2);
}

.download-cta:hover {
  background-color: #e0f2fe;
  transform: translateY(-3px);
  box-shadow: 0 12px 30px rgba(0, 0, 0, 0.3);
}

.download-cta .material-symbols-outlined {
  font-size: 1.2rem;
  color: #129bef;
  transition: transform 0.3s ease;
}

.download-cta:hover .material-symbols-outlined {
  transform: translateX(5px);
}

.cta-info {
  font-size: 0.9rem;
  opacity: 0.7;
  margin-top: 10px;
}

@media (max-width: 768px) {
  .ebook-cta-section {
    padding: 60px 15px;
    min-height: auto;
  }

  .cta-container {
    gap: 15px;
  }

  .cta-title {
    font-size: clamp(1.8rem, 6vw, 2.5rem);
  }

  .cta-description {
    font-size: 1rem;
  }

  .download-cta {
    padding: 12px 25px;
    font-size: 1rem;
  }
}

@media (max-width: 480px) {
  .cta-title {
    font-size: clamp(1.5rem, 7vw, 2rem);
  }

  .cta-description {
    font-size: 0.9rem;
  }

  .cta-info {
    font-size: 0.8rem;
  }
}
</style>
